import { z } from "zod";

export const renameFileSchema = z.object({
  filename: z.string().min(1, "Filnavn kan ikke være tomt"),
  videoId: z.string(),
});

export type RenameFileSchema = z.infer<typeof renameFileSchema>;
